var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "id_4 clear" },
    [
      _c("div", { staticClass: "tabs_box" }, [
        _c(
          "div",
          {
            staticClass: "tabs clear",
            style: { left: _vm.arrowIndex * -116 + "px" }
          },
          _vm._l(_vm.data.list, function(o, index) {
            return _c(
              "div",
              {
                key: o.tabs + index,
                staticClass: "tabs_item cursor fl",
                class: { back: _vm.indexs == index },
                on: {
                  click: function($event) {
                    _vm.indexs = index
                  }
                }
              },
              [_vm._v(_vm._s(o.tabs))]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm.data.list.length > 6
        ? _c("div", { staticClass: "arrow" }, [
            _vm.arrowIndex != 0
              ? _c("div", {
                  staticClass: "left cursor el-icon-arrow-left",
                  on: {
                    click: function($event) {
                      return _vm.arrow(1)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.arrowIndex != _vm.data.list.length - 6
              ? _c("div", {
                  staticClass: "right cursor el-icon-arrow-right",
                  on: {
                    click: function($event) {
                      return _vm.arrow(2)
                    }
                  }
                })
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.data.list, function(i, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.indexs == index,
                expression: "indexs==index"
              }
            ],
            key: i.title + index,
            staticClass: "box"
          },
          [
            _c("div", {
              staticClass: "title bold",
              domProps: { innerHTML: _vm._s(i.title) }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "text",
              attrs: { id: "id_4_img" },
              domProps: { innerHTML: _vm._s(i.text) }
            })
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-80b067b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-80b067b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/course/public/id_4.vue
// module id = null
// module chunks = 